import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import {
  Typography,
  Tab,
  TextField,
  InputAdornment,
  IconButton
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Tabs from '@material-ui/core/Tabs';
import SearchIcon from '@material-ui/icons/Search';

import { AppHeader, SelectCompanyBox, TabPanel } from 'components';
import RentalItemsBookingsListTable from './components/RentalBookingListTable';
import CancelledBookingsListTable from './components/CancelledBookingsListTable';



import useStyles from 'pages/bookings-list/styles';

function verticalTabProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`
  };
}

const CURRENT_TAB_INDEX = 0;
const CANCELLED_TAB_INDEX = 1;


const BookingList = ({ location, businessOwner }) => {
  const classes = useStyles();
  const [t] = useTranslation();
  const history = useHistory();

  const [value, setValue] = React.useState(
    location.state ? location.state.tabNumber : 0
  );
  const [searchField, setSearchField] = React.useState(undefined);
  const [search, setSearch] = React.useState(undefined);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  const handleSearchField = e => {
    setSearchField(e.target.value);
  };

  const onKeyDownHandler = e => {
    if (e.keyCode === 13) {
      setSearch(searchField);
    }
  };

  return (
    <div className={classes.root}>
      <AppHeader />

      {!businessOwner.selectedBusinessOwner.id && <SelectCompanyBox />}

      {businessOwner.selectedBusinessOwner.id && (
        <div className={classes.wrapper}>
          <div className={classes.toolbar}>
            <div className={classes.toolbarLeft}>
              <Typography variant="h2" className={classes.toolbarTitle}>
                {t('Bookings')}
              </Typography>
            </div>
            <div className={classes.toolbarSwitchers}>
              <Tabs
                indicatorColor="primary"
                value={value}
                onChange={handleChange}
              >
                <Tab
                  classes={{
                    root: classes.customTabRoot,
                    wrapper: classes.customTabWrapper,
                    selected: classes.selected,
                    textColorInherit: classes.textColorInheritCustom
                  }}
                  label={t('Current')}
                  {...verticalTabProps(CURRENT_TAB_INDEX)}
                />
                <Tab
                  classes={{
                    root: classes.customTabRoot,
                    wrapper: classes.customTabWrapper,
                    selected: classes.selected,
                    textColorInherit: classes.textColorInheritCustom
                  }}
                  label={t('Cancelled')}
                  {...verticalTabProps(CANCELLED_TAB_INDEX)}
                />
              </Tabs>
            </div>
            
            <div>
              <TextField
                classes={{
                  root: classes.searchField
                }}
                placeholder="Search..."
                variant="outlined"
                value={searchField}
                onChange={handleSearchField}
                onKeyDown={onKeyDownHandler}
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      onClick={() => setSearch(searchField)}
                    >
                      <IconButton>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </div>
            <div className={classes.toolbarRight}>
              <Button
                onClick={() => {
                  history.push(`/rental-items`);
                }}
                variant="outlined"
                color="primary"
                classes={{ root: classes.buttonRoot }}
              >
                {t('Book Rental')}
              </Button>
            </div>
          </div>
          <div className={classes.tabsRoot}>
            <TabPanel
              className={classes.tabContentWrapper}
              value={value}
              index={CURRENT_TAB_INDEX}
            >
              <RentalItemsBookingsListTable
                search={search}
              />
            </TabPanel>
            <TabPanel
              className={classes.tabContentWrapper}
              value={value}
              index={CANCELLED_TAB_INDEX}
            >
              <CancelledBookingsListTable
                search={search}
              />
            </TabPanel>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  businessOwner: state.businessOwner
});

export default connect(mapStateToProps, null)(BookingList);
